import { createContext, useContext, useState } from 'react';

type SpaContextType = {
  pageChosen: number;
  visible: boolean;
  expanded: boolean;
  getLocation: string
  setPageChosen: (newState: number) => void;
  setVisible: (newState: boolean) => void;
  setExpanded: (newState: boolean) => void;
  setGetLocation: (newState: string) => void;
};

const SpaContext = createContext<SpaContextType>({
  pageChosen: 0,
  visible: true,
  expanded: true,
  getLocation: '',
  setGetLocation(newState) {
    throw new Error('Function not implemented.');
  },
  setPageChosen: function (): {} {
    throw new Error('Function not implemented.');
  },
  setVisible: function (): {} {
    throw new Error('Function not implemented.');
  },
  setExpanded: function (): {} {
    throw new Error('Function not implemented.');
  }

});

const SpaProvider = ({ children }: any) => {
  const [pageChosen, setPageChosen] = useState<number>(0);
  const [visible, setVisible] = useState<boolean>(true);
  const [expanded, setExpanded] = useState<boolean>(true);
  const [getLocation, setGetLocation] = useState<string>('');

  return (
    <SpaContext.Provider
      value={{
        visible,
        setVisible,
        pageChosen,
        setPageChosen,
        expanded,
        setExpanded,
        getLocation,
        setGetLocation,
      }}
    >
      {children}
    </SpaContext.Provider>
  );
};

const useSpaProvider = () => {
  const context = useContext(SpaContext);
  return context;
};

export { useSpaProvider, SpaProvider };
